// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2YAoD","loaderOuter":"PageOverlayLoader_loaderOuter__308Lf"};